<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="employee-tab-inner">
            <div class="card-body container-fluid px-0">
                <b-form @submit.stop.prevent="onSubmit">
                    <input type="hidden" v-model="fdata.employee_id" name="employee_id">
                    <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>
                    <ul v-if="errormsg.length > 0">
                        <li clase="text-uppercase" v-for='data in errormsg'>{{ data[0] }}</li>
                    </ul>

                    <!-- notification  -->
                    <div v-if="number_of_contract_notification > 0"
                        class="alert alert-warning alert-dismissible fade show text-center ml-3" role="alert">
                        You have <strong> <span>{{ number_of_contract_notification }}</span>&nbsp; </strong> new
                        contract
                        notification. Please check.
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <!-- notification  -->

                    <div class="card bg-white mb-3 card_wizerd_company" v-if="show_contract_wizard">
                        <div class="card-body pt-0">
                            <div class="py-2 mb-3 px-2">
                                <div class="col-sm-12 px-3 company-form-box-title clearfix">
                                    <span v-if="contract_id == 0">Create</span>
                                    <span v-else>Update</span>
                                    Contract of {{ fdata.employee_name }}
                                    <span v-if="fdata.employee_jobposition">,</span>
                                    {{ fdata.employee_jobposition }}
                                    <span v-if="fdata.employee_department">,</span>
                                    {{ fdata.employee_department }}
                                    <div class="float-right">
                                        <b-button type="button" variant="primary"
                                            @click="show_contract_wizard = false;">Close</b-button>
                                    </div>
                                </div>
                            </div>

                            <div class="py-2 mb-3 border-bottom px-2">
                                <div class="col-sm-8 px-3 company-form-box-title clearfix"><label
                                        class="float-left mr-2">Type:</label><b-form-select id="payment_type"
                                        name="payment_type" v-model="payment_type" v-validate="{ required: true }"
                                        :options="payment_types" class="float-left w-25"></b-form-select></div>
                            </div>

                            <template v-if="fdata.employee_id">
                                <contract-wizard :employee_id="fdata.employee_id" :contract_id="latest_contract"
                                    :key="contFWizKey" @event="changeTabActiveContract"></contract-wizard>
                            </template>
                            <template v-else>
                                Server error!!! Please try again.
                            </template>
                        </div>
                    </div>
                    <div class="card bg-white ml-3 mb-3 d-none" v-if="c_flg">
                        <div class="card-body p-0 ">
                            <div class="py-2 d-none">
                                <div class="row company-form-box-title clearfix no-margin">
                                    <div class="col-6 text-right">
                                        <b-button v-if="$acl['contract/add'] > 1" type="button" variant="primary"
                                            @click="showContractWizard()">Create/Update Contract</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card bg-transparent ml-0 contract-front-container border-0 no-shadow">
                        <div class="card-body p-0">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="clearfix company-form-container h-100">
                                        <div class="py-3">
                                            <div class="col-sm-12 px-3 company-form-box-title clearfix">Current Contract
                                            </div>
                                        </div>

                                        <template v-if="contract_currently_active">
                                            <div class="px-3">
                                                <contract-view :contract_id="active_contract"
                                                    :key="contVWizKey"></contract-view>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="px-3">No current active contract available</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="clearfix company-form-container">
                                        <div class="col-md-12 px-3 pt-3 text-right" v-if="c_flg">
                                            <b-button v-if="$acl['contract/add'] > 1" type="button" variant="primary"
                                                @click="showContractWizard()">Create/Update Contract</b-button>
                                        </div>
                                        <div class="py-3">
                                            <div class="col-sm-12 px-3 company-form-box-title">All Contracts</div>
                                        </div>
                                        <div class="col-md-12 px-3">
                                            <div class="contract-archive-box pb-5">
                                                <ul class="contract-archive-list">
                                                    <li v-for="emp_contract in contract_lists" :key="emp_contract.id">
                                                        <div class="contract-archive-user">
                                                            <div class="before-circle"></div>
                                                        </div>
                                                        <div class="contract-archive-content">
                                                            <div class="timeline-content">
                                                                <div class="reference mb-0">
                                                                    <h4 class="table_text_color">
                                                                        {{ emp_contract.contract_reference }}</h4>
                                                                    <div class="text-right pr-2">
                                                                        <b-button
                                                                            v-if="emp_contract.status == 1 || emp_contract.status == 2"
                                                                            variant="primary" class=" custom-wizard-btn"
                                                                            @click="reviewContract(emp_contract.id)">
                                                                            View Contract
                                                                        </b-button>

                                                                        <a class="btn ml-2 btn-delete py-2 font-semi-bold"
                                                                            href="javascript:void(0);"
                                                                            :disabled="emp_contract.paylip_created == 1"
                                                                            :title="emp_contract.paylip_created == 1 ? 'Cannot be deleted as already used in payroll calculation' : 'Click to delete'"
                                                                            @click="removeContract(emp_contract.id, $event)"
                                                                            v-if="$acl['contract/update'] == 2"><b-icon
                                                                                icon="trash-fill"
                                                                                class="mr-2"></b-icon>Delete</a>
                                                                    </div>
                                                                    <div class="row mb-0">
                                                                        <div class="col-md-6 mb-0">
                                                                            <div>Contract Start Date: {{
                                                                                emp_contract.contract_start
                                                                                }}</div>
                                                                            <div>Probation: <template
                                                                                    v-if="emp_contract.has_probation == 1">{{
                                                                                        emp_contract.probation_start }}
                                                                                    -
                                                                                    {{ emp_contract.probation_end
                                                                                    }}</template><template
                                                                                    v-else>N/A</template></div>
                                                                            <div>Status: <template
                                                                                    v-if="emp_contract.status == 1">Active</template><template
                                                                                    v-else-if="emp_contract.status == 3">Draft</template><template
                                                                                    v-else>Archived</template></div>
                                                                        </div>
                                                                        <div class="col-md-6 mb-0">
                                                                            <div
                                                                                class="text-right position-relative pr-2">
                                                                                <!-- <b-button
                                                                                    v-if="emp_contract.status == 1 || emp_contract.status == 2"
                                                                                    variant="primary"
                                                                                    class=" custom-wizard-btn"
                                                                                    @click="reviewContract(emp_contract.id)">
                                                                                    View Contract
                                                                                </b-button> -->
                                                                                <!-- <b-button v-if="$acl['contract/update'] == 2"
                                                                                    class="btn ml-2 btn-delete py-2 px-3 font-semi-bold"
                                                                                    pill size="sm"
                                                                                    variant="primary"
                                                                                    :disabled="emp_contract.paylip_created == 1"
                                                                                    :title="emp_contract.paylip_created == 1 ? 'Cannot be deleted as already used in payroll calculation' : 'Click to delete'"
                                                                                    @click="removeContract(emp_contract.id, $event)">
                                                                                    <i class="trash-fill"></i>Delete
                                                                                </b-button> -->
                                                                                <!-- <a class="btn ml-2 btn-delete py-2 font-semi-bold"
                                                                                    href="javascript:void(0);"
                                                                                    :disabled="emp_contract.paylip_created == 1"
                                                                                    :title="emp_contract.paylip_created == 1 ? 'Cannot be deleted as already used in payroll calculation' : 'Click to delete'"
                                                                                    @click="removeContract(emp_contract.id, $event)"
                                                                                    v-if="$acl['contract/update'] == 2"><b-icon
                                                                                        icon="trash-fill"
                                                                                        class="mr-2"></b-icon>Delete</a> -->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- <div>Contract Start Date: {{ emp_contract.contract_start }}</div>
                                                                <div>Probation: <template v-if="emp_contract.has_probation==1">{{emp_contract.probation_start}} - {{emp_contract.probation_end}}</template><template v-else>N/A</template></div>
                                                                <div>Status: <template v-if="emp_contract.currently_active == 1  && emp_contract.id == active_contract">Active</template><template v-else-if="emp_contract.status==1">Inactive</template><template v-else-if="emp_contract.status==3">Pending</template><template v-else>Archived</template></div> -->
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
        <b-modal id="bv-modal-contract-details" hide-footer title="Contract Details" size="lg">
            <b-overlay :show="cntoverlay" rounded="sm">
                <contract-view :contract_id="review_contract" @event="contractViewUpdated"></contract-view>
            </b-overlay>
        </b-modal>
    </b-overlay>
</template>

<style scoped>
.active-bg {
    background-color: #E5FFF9 !important;
}

.custom-info {
    background: #f0f0f0;
    color: #585858;
}

.dashed-border {
    border-bottom: 1px dashed #000;
}
</style>

<script>
import moment from 'moment';
export default {

    mounted() {
    },

    computed: {
    },

    props: ['flg', 'contract_id'],
    data() {
        return {
            contract: [],
            fdata: [],
            contract_lists: [],
            active_contract: 0,
            latest_contract: 0,
            review_contract: 0,
            salary_settings: [],
            component_values: [],
            child_component_values: [],
            probation_salary: [],
            child_popup_title: '',
            child_popup_key: '',
            child_popup_components: [],
            child_component_data: [],
            optimize_fields: { house_rent: '0', conveyance_allowance: '0', medical_allowance: '0' },
            skip_optimization: 0,
            status: 1,
            contFWizKey: 0,
            contVWizKey: 0,
            trzsuccess: '',
            trzerrormsg: '',
            errormsg: [],
            loopidxtest: 0,
            successmsg: '',
            contract_action: '',
            contract_disable: true,
            c_flg: this.flg == 0 ? 0 : 1,
            showoverlay: false,
            cntoverlay: false,
            investmenturl: this.$api_url + '/investments/',
            contractTabs: 0,
            show_contract_wizard: false,
            contract_currently_active: false,
            hasDraft: false,

            payment_types: [
                { value: "0", text: "Monthly pay contract" },
                { value: "1", text: "Variable pay contract" },
            ],
            payment_type: 0,

            // Mustafijur: 05-05-2026
            number_of_contract_notification: 0,
        }
    },
    methods: {
        // MUstafijur: 05-05-2026: Starts
        get_contract_notification: function () {
            axios.get(this.pageurl + '/core-hr/employee/contract/notification')

                .then(function (response) {
                    this.number_of_contract_notification = response.data;
                    //this.get_contract_notification();
                }.bind(this));
        },
        // MUstafijur: 05-05-2026: Ends
        formatMe(d) {
            return moment(d).format('DD/MM/YYYY');
        },

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        contractViewUpdated(value) {
            if (value == 'approval') {
                this.$bvModal.hide('bv-modal-contract-details');
                this.getContractLists();
                this.$emit('event', 'added');
            }
        },

        checkGrossSalary(field_key) {
            var optimize_salary_fields = ['basic_salary', 'house_rent', 'conveyance_allowance', 'medical_allowance'];
            var curr_gross = 0;
            if (optimize_salary_fields.includes(field_key)) {
                for (var f_key in optimize_salary_fields) {
                    if (this.component_values[optimize_salary_fields[f_key]]) {
                        curr_gross = curr_gross + parseInt(this.component_values[optimize_salary_fields[f_key]]);
                    }
                }
                if (curr_gross > 0)
                    this.fdata.gross = curr_gross;
            }
        },
        checkProbationGrossSalary(field_key) {
            var optimize_salary_fields = ['probation_basic_salary', 'probation_house_rent', 'probation_conveyance_allowance', 'probation_medical_allowance'];
            var curr_gross = 0;
            if (optimize_salary_fields.includes(field_key)) {
                for (var f_key in optimize_salary_fields) {
                    if (this.probation_salary[optimize_salary_fields[f_key]] && f_key != 'probation_gross_salary') {
                        curr_gross = curr_gross + parseInt(this.probation_salary[optimize_salary_fields[f_key]]);
                    }
                }
                if (curr_gross > 0)
                    this.probation_salary['probation_gross_salary'] = curr_gross;
            }
        },

        setChildComponents(parent_key, child_data) {
            //console.log("parent_key");
            if (parent_key && child_data) {
                //console.log(parent_key);
                this.child_component_values[parent_key] = child_data;
                for (var c_data in child_data) {
                    this.component_values[child_data[c_data].field_key] = child_data[c_data].field_value;
                }
            }
        },

        setComponentValues: function () {
            //this.loopidxtest++;
            //console.log('setComponentValues call '+this.loopidxtest);

            if (this.salary_settings.fixed.length > 0) {
                var optimize_fields_array = ['house_rent', 'conveyance_allowance', 'medical_allowance'];

                for (var c_data in this.salary_settings.fixed) {
                    if (parseInt(this.salary_settings.fixed[c_data].date_range) != 1)
                        this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].field_value;
                    else
                        this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].is_checked;

                    if (optimize_fields_array.includes(this.salary_settings.fixed[c_data].field_name))
                        this.optimize_fields[this.salary_settings.fixed[c_data].field_name] = '1';

                    if (parseInt(this.salary_settings.fixed[c_data].section_only) > 0) {
                        if (this.salary_settings.fixed[c_data].child_components)
                            this.setChildComponents(this.salary_settings.fixed[c_data].field_name, this.salary_settings.fixed[c_data].child_components);
                    }
                }
            }

            if (this.salary_settings.fixed_deduction.length > 0) {
                for (var m_data in this.salary_settings.fixed_deduction) {

                    this.component_values[this.salary_settings.fixed_deduction[m_data].field_name] = this.salary_settings.fixed_deduction[m_data].field_value;
                    if (parseInt(this.salary_settings.fixed_deduction[m_data].section_only) > 0) {
                        if (this.salary_settings.fixed_deduction[m_data].child_components)
                            this.setChildComponents(this.salary_settings.fixed_deduction[m_data].field_name, this.salary_settings.fixed_deduction[m_data].child_components);
                    }
                }
            }
            //console.log('Comes here');
            if (this.salary_settings.reserved_data) {
                //console.log('Enter Comes here');
                for (var r_data in this.salary_settings.reserved_data) {
                    if (!this.salary_settings.reserved_data[r_data].start) {
                        if (this.salary_settings.reserved_data[r_data].field_key)
                            this.component_values[this.salary_settings.reserved_data[r_data].field_key] = this.salary_settings.reserved_data[r_data].field_value;
                        //console.log('Field Key: '+this.salary_settings.reserved_data[r_data].field_key+', Field Value: '+this.salary_settings.reserved_data[r_data].field_value);
                    }
                }
                this.fdata.gross = this.salary_settings.reserved_data.gross_salary.field_value;
            }


            if (this.salary_settings.probation_data) {
                //console.log('Enter Comes here');
                for (var p_data in this.salary_settings.probation_data) {
                    if (this.salary_settings.probation_data[p_data].field_key)
                        this.probation_salary[this.salary_settings.probation_data[p_data].field_key] = this.salary_settings.probation_data[p_data].field_value;
                    //console.log('Field Key: '+this.salary_settings.probation_data[p_data].field_key+', Field Value: '+this.salary_settings.probation_data[p_data].field_value);
                }
            }
        },


        getActiveContract: function () {
            if (this.contract_lists) {
                for (var contract_data in this.contract_lists) {
                    if (this.contract_lists[contract_data].currently_active == 1) {
                        this.active_contract = this.contract_lists[contract_data].id;
                        this.contract_currently_active = true;
                        this.latest_contract = this.contract_lists[contract_data].id;
                    }

                    if (!this.contract_currently_active && this.contract_lists[contract_data].status != 3)
                        this.latest_contract = this.contract_lists[contract_data].id;
                }
                //if(this.active_contract){
                //this.latest_contract = this.active_contract;
                if (this.active_contract)
                    this.contVWizKey = this.contVWizKey + 1;
            }
        },

        checkHasDraft: function () {
            this.hasDraft = false;

            if (this.$acl['contract/update'] == 2) {

                if (this.contract_lists) {
                    for (var contract_data in this.contract_lists) {
                        if (this.contract_lists[contract_data].status == 3 && this.contract_lists[contract_data].need_approval == 1) {
                            this.hasDraft = true;
                            break;
                        }
                    }
                }
            }
        },

        getContractLists: function () {
            this.showoverlay = true;
            axios.get(this.$api_url + '/allcontracts', {
                params: {
                }
            }).then(function (response) {

                this.contract_lists = response.data.data;

                this.getActiveContract();
                this.checkHasDraft();
                this.showoverlay = false;
                //console.log(response.data.data);
            }.bind(this)).catch(function (error) {
                if (error.response.status == 500)
                    this.$bvToast.toast("Server error. Please try again!!!", { title: 'Error!!!', variant: 'danger', solid: true });
                else
                    currentObj.errormsg = error.response.data.errors;
            });
        },

        getSalarySettings: function () {

            axios.get(this.$api_url + '/employeesalarysettings/' + this.contract.employee_id + '/' + this.contract.id, {
                params: {
                }
            }).then(function (response) {
                this.salary_settings = response.data.data;
                this.setComponentValues();


            }.bind(this));
        },

        setDateRangeValue(tKey, currVal) {

            if (parseInt(currVal) == 0) {
                this.component_values[tKey + '_start_date'] = '';
                this.component_values[tKey + '_end_date'] = '';
            }

        },

        intializeContractDates: function () {
            if (this.contract.probation_start == '0000-00-00')
                this.fdata.probation_start = '';
            if (this.contract.probation_end == '0000-00-00')
                this.fdata.probation_end = '';
            if (this.contract.contract_start == '0000-00-00')
                this.fdata.contract_start = '';
            if (this.contract.contract_end == '0000-00-00')
                this.fdata.contract_end = '';
            if (this.contract.pf_start == '0000-00-00')
                this.fdata.pf_start = '';

        },
        employeeInfo() {
            this.showoverlay = true;
            axios.get(this.$api_url + '/employee/publicinfo', {
                params: {
                }
            }).then(function (response) {
                if (response.data) {
                    //console.log(response.data);
                    if (response.data.name)
                        this.fdata.employee_name = response.data.name;
                    this.fdata.employee_jobposition = response.data.jobposition;
                    this.fdata.employee_department = response.data.department;

                    if (response.data.employee_id) {
                        this.fdata.employee_id = response.data.employee_id;
                        this.getContractLists();
                        this.contFWizKey = this.contFWizKey + 1;
                    }


                }
                this.showoverlay = false;
            }.bind(this));
        },

        changeTabActiveContract(params) {
            this.triggerActiveContract();
            this.contractTabs = this.contractTabs + 1;
            if (params == 'success') {
                this.$bvToast.toast('Successfully saved', { title: 'Success', variant: 'success', solid: true });
                this.$emit('event', 'added');
            }

        },

        triggerContractArchive() {
            this.review_contract = 0;
            this.getContractLists();
        },

        triggerActiveContract() {
            this.getContractLists();
        },

        reviewContract(contract_id) {
            this.review_contract = contract_id;
            this.$bvModal.show('bv-modal-contract-details');
        },

        // alpha fix- commented this
        // removeContract(cont_id, e){
        //     e.preventDefault();
        //     if(confirm("Do you really want to delete this contract?")){
        //       let formData = new FormData();
        //       formData.append('contract_id', cont_id);
        //       let currentObj = this;
        //       const config = {
        //       }

        //       axios.post(this.$api_url + '/deletecontract', formData, config)
        //                 .then(function (response)
        //                 {
        //                     if(response.data.success){
        //                         this.$bvToast.toast(response.data.message, {title: 'Success',variant: 'success',solid: true});
        //                         this.getContractLists();
        //                         this.$emit('event','removed');
        //                     }else if(response.data.error){
        //                        this.$bvToast.toast(response.data.message, {title: 'Error!',variant: 'danger',solid: true});
        //                     }
        //                 }.bind(this))
        //                 .catch(function (error)
        //                 {
        //                     this.$bvToast.toast(error.response.data.errors.toString(), {title: 'Error!',variant: 'danger',solid: true});
        //                 });
        //     }
        // } ,

        // alpha fix added this
        removeContract(cont_id, e) {
            e.preventDefault();

            // alpha fix- chnaged native confirm() alert to $bvModal.msgBoxConfirm popup style
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this contract.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let formData = new FormData();
                        formData.append('contract_id', cont_id);
                        const config = {
                        }

                        axios.post(this.$api_url + '/deletecontract', formData, config)
                            .then(function (response) {
                                if (response.data.success) {
                                    this.$bvToast.toast(response.data.message, { title: 'Success', variant: 'success', solid: true });
                                    this.getContractLists();
                                    this.$emit('event', 'removed');
                                } else if (response.data.error) {
                                    this.$bvToast.toast(response.data.message, { title: 'Error!', variant: 'danger', solid: true });
                                }
                            }.bind(this))
                            .catch(function (error) {
                                this.$bvToast.toast(error.response.data.errors.toString(), { title: 'Error!', variant: 'danger', solid: true });
                            });
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },
        showContractWizard: function () {
            this.show_contract_wizard = true;
        }
    },
    created: function () {
        this.employeeInfo();
    }
}
</script>
